import { $api } from '@shared/api';
import { handleAxiosFetchErrorsSwal } from '@shared/helpers/fetchHelpers';

export const getCurrency = async () => {
    // @ts-ignore
    const eventJournalListUrl = routable.getRoute('getCurrencyList');
    try {
        const response = await $api.get(eventJournalListUrl);
        return response.data;
    } catch (error) {
        handleAxiosFetchErrorsSwal(error?.response?.data);
        return error;
    }
};
